import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { sendMessageError, sendMessageSuccess } from '../../actions/toast';
import CircularProgress from '@material-ui/core/CircularProgress';
import { getTypeEtablissement, updateTypeEtablissement } from '../../actions/typeEtablissement';

export default class UpdateTypeEtablissement extends React.Component {
    state = {
        id: '',
        nom: '',
        loading: true,
    };

    componentDidMount() {
        const id = this.props.match.params.id;
        if (id?.length === 0) {
            this.props.history.push("/types-etablissement");
            return;
        }

        getTypeEtablissement(id)
            .then(typeEtablissement => {
                this.setState({
                    id,
                    nom: typeEtablissement.nom,
                    loading: false,
                });
            })
            .catch(error => {
                console.log(error);
                sendMessageError(error);
            });
    }

    handleInput = (identifiant, e) => {
        this.setState({
            [identifiant]: e.target.value,
        });
    };

    handleSubmit = () => {
        updateTypeEtablissement(this.state.id, this.state.nom)
            .then(() => {
                sendMessageSuccess("Type d'établissement bien modifié !");
                this.props.history.push("/types-etablissement");
            })
            .catch(error => sendMessageError(error));
    };

    render() {
        const { nom,loading } = this.state;

        if (loading) {
            return <div className="content-wrapper">
                <section className="content-header">
                    <CircularProgress />
                </section>
            </div>;
        }

        return (
            <div className="content-wrapper">
                <section className="content-header">
                    <h1>
                        Modifier un type d'établissement
                    </h1>
                    <ol className="breadcrumb">
                        <li>
                            <Button onClick={() => this.props.history.push("/types-etablissement")}>
                                <i className="fa fa-dashboard"></i>
                                Types d'établissement
                            </Button>
                        </li>
                        <li className="active">
                            Modifier un type d'établissement
                        </li>
                    </ol>
                </section>
                <section className="content">
                    <div className="row">
                        <div className="col-md-6 col-md-offset-3">
                            <div className="box box-primary">
                                <div className="box-header with-border">
                                    <h3 className="box-title">Informations</h3>
                                </div>
                                <form role="form">
                                    <div className="box-body">
                                        <div className="form-group">
                                            <TextField
                                                label="Nom"
                                                value={nom}
                                                fullWidth={true}
                                                onChange={e => this.handleInput("nom", e)}
                                            />
                                        </div>
                                    </div>

                                    <div className="box-footer text-center">
                                        <Button
                                            onClick={this.handleSubmit}
                                            color="primary"
                                        >
                                            Modifier
                                        </Button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}
